module.exports = "/assets/data/1a9da5b83aaed4592d511db66d8c9475-SO30.data.json";